<template>
    <div>
        <h1 class="text-lg font-bold">{{displayName | capitalizeFirstLetter}} introuvable</h1>

        <div class="mt-2">{{ $t('form.appareil.nous_sommes_navres') }}</div>

        <sav-input
        type="text"
        class="my-3"
        :placeholder="$t('form.appareil.nom_du_modele')"
        rows="5"
        v-model="requestComment"
        />

        <label class="mt-5 block mb-2 text-sm font-medium">{{ $tt('Vérification de spam') }}</label>
        <div class="mb-4" id="recaptcha" ref="recaptcha"></div>

        <button :disabled="loadingRequest" @click="sendRequestForm()" class="p-2 px-4 text-sm font-light text-white duration-200 bg-green-500 hover:bg-green-600 rounded-xl">
            <i class="fa-solid fa-check mr-0.5"></i> {{ $tt('Envoyer') }}
        </button>
        <button :disabled="loadingRequest" @click="$emit('close')" class="p-2 px-4 text-sm font-light duration-200 bg-gray-300 hover:bg-gray-400 rounded-xl">
            <i class="fa-solid fa-times mr-0.5"></i> {{ $tt('Annuler') }}
        </button>
    </div>
</template>

<script>
import apiService from '@/services/api.service'

export default {
    props: {
        displayName: {
            type: String,
            required: true
        },
        libelle: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            requestComment: null,
            loadingRequest: false,
            validCaptcha: false,
        }
    },

    computed: {
        uniqueId() {
            let id = this.displayName.replace(' ', '-')
            return 'modal-request-' + id + '-' + Date.now()
        }
    },

    filters: {
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    },

    methods: {
        async sendRequestForm() {
            if (!this.requestComment) {
                this.$toast.error('Formulaire incomplet')
                return
            }

            if (!this.validCaptcha) {
                this.$toast.error('Merci de valider la vérification de spam')
                return
            }

            this.loadingRequest = true

            let client_id = 0
            if (localStorage.getItem('client_id')) {
                client_id = this.$crypto.decrypt(localStorage.getItem('client_id'))
            }

            let response = await apiService.post('no_ref', {
                comment: this.requestComment,
                libelle: this.libelle,
                id_conso: client_id
            })
            if (response.data && response.data.posts.post == '1') {
                this.$modal.hide(this.uniqueId)
                localStorage.removeItem('form-data')
                this.$router.push({name: 'home', query: {app_not_found: 1}})
            }
            this.$emit('close')
            this.loadingRequest = false
        },

        loadRecaptcha() {
            grecaptcha.render(this.$refs.recaptcha, {
                sitekey: "6Ld3v-8qAAAAAPYfiLgj2DZ2xu9rsmUm8-3_Ey2A", // Captcha gérer sur production@savlog.net
                callback: this.onRecaptchaSuccess, 
                'expired-callback': this.onRecaptchaExpired
            });
        },
        onRecaptchaSuccess() {
            this.validCaptcha = true
        },
        onRecaptchaExpired() {
        },
    },

    mounted() {
        // Vérifier si l'API Google reCAPTCHA est bien chargée
        if (typeof grecaptcha !== "undefined") {
            this.loadRecaptcha();
        } else {
            window.vueRecaptchaCallback = this.loadRecaptcha;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/SavRequestModal.vue